module.exports = __webpack_public_path__ + "img/settings_products.4a0d0bcf.jpg";